"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getFoundryDefaultHeaders_1 = __importDefault(require("../../getFoundryDefaultHeaders"));
var originHeader_1 = require("@fuze/apis-core/dist/originHeader");
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Add a peer to a location's emergency contacts
 *
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param origin An identifier for the application make the API request
 * @param locationId The id of the location being requested
 * @param peerId The id of the peer to add to the emergency contacts
 */
function createLocationEmergencyContact(baseUrl, wardenToken, origin, locationId, peerId) {
    return (0, http_client_1.default)({
        method: "POST",
        url: baseUrl + "/v1/locations/" + locationId + "/ist",
        headers: __assign(__assign({}, (0, getFoundryDefaultHeaders_1.default)(wardenToken)), (0, originHeader_1.createOriginHeader)(origin)),
        data: { peerId: peerId }
    }).then(function (response) { return response.data; });
}
exports.default = createLocationEmergencyContact;
